"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryBlocksApi = void 0;
var BringgException_1 = require("../Core/BringgException");
var DeliveryBlocksEntity_1 = __importDefault(require("./Entity/DeliveryBlocksEntity"));
var DeliveryBlocksApi = /** @class */ (function () {
    function DeliveryBlocksApi(session) {
        this.deliveryBlocksEntity = new DeliveryBlocksEntity_1.default(session);
    }
    DeliveryBlocksApi.prototype.get = function (teamId, startTime, endTime, dateRangeType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deliveryBlocksEntity.get(teamId, startTime, endTime, dateRangeType)];
            });
        });
    };
    DeliveryBlocksApi.prototype.create = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deliveryBlocksEntity.create(options)];
            });
        });
    };
    DeliveryBlocksApi.prototype.update = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deliveryBlocksEntity.update(options)];
            });
        });
    };
    DeliveryBlocksApi.prototype.delete = function (id, recurring) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deliveryBlocksEntity.delete(id, recurring)];
            });
        });
    };
    DeliveryBlocksApi.prototype.getByDriverId = function (driverId, startTime, endTime, teamId, dateRangeType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deliveryBlocksEntity.getByDriverId(driverId, startTime, endTime, teamId, dateRangeType)];
            });
        });
    };
    DeliveryBlocksApi.prototype.getTemplates = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deliveryBlocksEntity.getTemplates()];
            });
        });
    };
    DeliveryBlocksApi.prototype.getTemplateById = function (templateId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deliveryBlocksEntity.getTemplateById(templateId)];
            });
        });
    };
    DeliveryBlocksApi.prototype.createTemplate = function (template) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deliveryBlocksEntity.createTemplate(template)];
            });
        });
    };
    DeliveryBlocksApi.prototype.updateTemplate = function (templateId, payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deliveryBlocksEntity.updateTemplate(templateId, payload)];
            });
        });
    };
    DeliveryBlocksApi.prototype.deleteTemplate = function (templateId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deliveryBlocksEntity.deleteTemplate(templateId)];
            });
        });
    };
    __decorate([
        BringgException_1.logOnException
    ], DeliveryBlocksApi.prototype, "get", null);
    __decorate([
        BringgException_1.logOnException
    ], DeliveryBlocksApi.prototype, "create", null);
    __decorate([
        BringgException_1.logOnException
    ], DeliveryBlocksApi.prototype, "update", null);
    __decorate([
        BringgException_1.logOnException
    ], DeliveryBlocksApi.prototype, "delete", null);
    __decorate([
        BringgException_1.logOnException
    ], DeliveryBlocksApi.prototype, "getByDriverId", null);
    __decorate([
        BringgException_1.logOnException
    ], DeliveryBlocksApi.prototype, "getTemplates", null);
    __decorate([
        BringgException_1.logOnException
    ], DeliveryBlocksApi.prototype, "getTemplateById", null);
    __decorate([
        BringgException_1.logOnException
    ], DeliveryBlocksApi.prototype, "createTemplate", null);
    __decorate([
        BringgException_1.logOnException
    ], DeliveryBlocksApi.prototype, "updateTemplate", null);
    __decorate([
        BringgException_1.logOnException
    ], DeliveryBlocksApi.prototype, "deleteTemplate", null);
    return DeliveryBlocksApi;
}());
exports.DeliveryBlocksApi = DeliveryBlocksApi;
//# sourceMappingURL=DeliveryBlocksApi.js.map